import { Alert, Button, Card, Input, Label, TextField } from '@heroui/react'
import { getAuthInstance } from '@zealth/core/firebase/runtime'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { type FormEvent, type ReactNode, useState } from 'react'

export const CentredPanel = ({ children }: { children: ReactNode }) => (
  <div className="bg-background flex min-h-screen items-center justify-center p-4">
    <Card className="w-full max-w-[420px] rounded-xl p-8">{children}</Card>
  </div>
)

/** Email + password, the same method the playground admin uses. */
const SignInScreen = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault()
    setError('')
    try {
      await signInWithEmailAndPassword(getAuthInstance(), email, password)
    } catch {
      // One message for every failure: naming which of email or password
      // was wrong tells an outsider which addresses exist.
      setError('That email and password did not match an account.')
    }
  }

  return (
    <CentredPanel>
      <h1 className="mb-6 text-xl font-semibold tracking-tight">
        Zealth Insights
      </h1>
      <form onSubmit={handleSubmit} className="grid gap-4">
        <TextField
          name="email"
          type="email"
          value={email}
          onChange={setEmail}
          isRequired
          fullWidth
        >
          <Label>Email</Label>
          <Input autoComplete="username" />
        </TextField>
        <TextField
          name="password"
          type="password"
          value={password}
          onChange={setPassword}
          isRequired
          fullWidth
        >
          <Label>Password</Label>
          <Input autoComplete="current-password" />
        </TextField>
        <Button type="submit" variant="primary" fullWidth>
          Sign in
        </Button>
        {error && (
          <Alert status="danger">
            <Alert.Indicator />
            <Alert.Content>
              <Alert.Description>{error}</Alert.Description>
            </Alert.Content>
          </Alert>
        )}
      </form>
    </CentredPanel>
  )
}

export default SignInScreen
